import {
  SearchFormValues,
  SEARCH_FORM_NAME,
  ELITE_SEARCH_FORM_NAME,
  REFUGEE_SEARCH_FORM_NAME,
} from 'components/search/search.logic';
import { useSelector } from 'react-redux';
import { getFormValues } from 'redux-form';

export const useSearchForm = () => {
  const formValues = useSelector(getFormValues(SEARCH_FORM_NAME)) as SearchFormValues | undefined;
  const cityToDisplay = formValues?.citySlugResolved || '';
  const subjectToDisplay = formValues?.subjectSlugResolved || '';

  return { cityToDisplay, subjectToDisplay };
};

export const useSearchEliteForm = () => {
  const formValues = useSelector(getFormValues(ELITE_SEARCH_FORM_NAME)) as
    | SearchFormValues
    | undefined;
  const cityToDisplay = formValues?.citySlugResolved || '';
  const subjectToDisplay = formValues?.subjectSlugResolved || '';

  return { cityToDisplay, subjectToDisplay };
};

export const useSearchRefugeeForm = () => {
  const formValues = useSelector(getFormValues(REFUGEE_SEARCH_FORM_NAME)) as
    | SearchFormValues
    | undefined;
  const cityToDisplay = formValues?.citySlugResolved || '';
  const subjectToDisplay = formValues?.subjectSlugResolved || '';

  return { cityToDisplay, subjectToDisplay };
};
